
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApplications } from "@/hooks/use-applications";
import { ReceivedQuotes } from "./ReceivedQuotes";
import { useAuth } from "@/contexts/AuthContext";
import { BrokerDashboard } from "../broker/BrokerDashboard";
import { BrokerLinkDialog } from "../broker/BrokerLinkDialog";
import { useToast } from "@/hooks/use-toast";
import { UnifiedApplications } from "./UnifiedApplications";
import { EmailVerificationBanner } from "../auth/EmailVerificationBanner";
import { ThreePathwayHero } from "./hero/ThreePathwayHero";

export const DashboardContent = () => {
  const { applications, isLoading, startNewApplication, refetch } = useApplications();
  const [isStartingNew, setIsStartingNew] = useState(false);
  const { userRole } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  
  useEffect(() => {
    const submissionFlag = sessionStorage.getItem('applicationSubmitted');
    
    if (submissionFlag) {
      console.log('Dashboard detected application submission, refreshing data');
      refetch().then(() => {
        console.log('Applications data refreshed after submission');
      });
    }
  }, [refetch]);
  
  const handleStartNewApplication = async () => {
    setIsStartingNew(true);
    try {
      await startNewApplication();
    } finally {
      setIsStartingNew(false);
    }
  };
  
  const handleApplicationDeleted = async () => {
    try {
      await refetch();
    } catch (error) {
      console.error('Error refreshing applications:', error);
    }
  };
  
  if (userRole === 'broker') {
    return <BrokerDashboard />;
  }
  
  if (userRole === 'peo') {
    navigate('/peo/dashboard');
    return null;
  }
  
  return (
    <div className="container mx-auto py-6 space-y-8 px-4 sm:px-6">
      {/* Email Verification Banner */}
      <EmailVerificationBanner />
      
      {/* Header with title and broker link button */}
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold">Dashboard</h2>
        <BrokerLinkDialog />
      </div>
      
      {/* Three Pathway Hero Section */}
      <ThreePathwayHero 
        onStartNewApplication={handleStartNewApplication}
        isStartingNew={isStartingNew}
        isLoading={isLoading}
      />
      
      {/* Applications Section - no redundant header */}
      <UnifiedApplications onApplicationDeleted={handleApplicationDeleted} />
      
      {/* Quotes Section - no redundant header */}
      <ReceivedQuotes />
    </div>
  );
};
